module.exports = __webpack_public_path__ + "static/media/ladyAfter.347a79a4.jpg";